export const usersApis = {
    getUsersList: "v1/api/users",
    createUser: "v1/api/users",
    deleteUsers: "v1/api/users?Id=:userId",
    updateUser: "v1/api/users/update",
    getUserById: "v1/api/users/details?Id=:userId",
    uploadDocumentById: "v1/api/users/uploadDocById",
    removeDocumentById: "v1/api/users/removeUploadDocById",
    resendInvite: "v1/api/users/resentInvite?Id=:userId",
    verifyEmailForDomain: 'v1/api/users/verifyEmailForDomain',
    fetchUserInventory: 'api_mongo/user_inventory_master.php?userId=',
    fetchUserLeaveComment: 'api_mongo/user_leave_comment.php?userId=',
    fetchUserAttendance: 'api_mongo/user_attendance_report.php?userId=',
    fetchSalaryDetails: 'api_mongo/user_salary_structure.php?userId=',
    fetchSalarySlipDetails: 'api_mongo/user_salary_slip_generate.php?userId=',
    fetchSalarySlipDownload: 'api_mongo/user_salary_slip_download.php?userId=',
    fetchUserLeaveHoliday: 'api_mongo/user_holiday_list.php',
    fetchUserLeaveLog: 'api_mongo/user_holiday_apply_list.php?userId=',
    applyLeaveComment: 'leavescomment',
    attendanceComment: 'attendancecomment',
    attendanceHoliday: 'leaves',
    // fetchUserCallList: 'api_mongo/user_calling_list.php',
    // fetchUserCallList: 'v1/api/users/userextension?username=atif&university=70&jobrole=1',
    fetchUserCallList: 'v1/api/users/userextension',
    agentMakeCall: 'v1/api/ipbx/dial_agent_outbound',
    extMakeCall: 'v1/api/ipbx/dial_extension',
    extMakeLogin: 'v1/api/ipbx/login',
    extMakeOutBoundCall: 'v1/api/ipbx/dial_outbound',
    caseowner: 'v1/api/applicationProcess/getreassignuser',
    caseownerV2: 'v1/api/application/caseowner',
    caseownerV3:'v1/api/users/getAllCaseOwners',
    crizacCommission: 'api_mongo/agent/agent_commission_structure.php?storeId=1',
    ucolCommission: 'api_mongo/agent/agent_commission_structure.php?storeId=2',
    marketingUserList:'v1/api/users?jobRoleId=',
    searchAgent:'v1/api/agents/superAdmin',
    refferedBy:'v1/api/agents/getAllReferrers',
    fetchUseWFHService: "v1/api/wfh",
    createWFH: "v1/api/wfh/create"
}
